import { render, staticRenderFns } from "./ProductOptionForm.vue?vue&type=template&id=1458249e&"
import script from "./ProductOptionForm.vue?vue&type=script&lang=js&"
export * from "./ProductOptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports